module.exports = __webpack_public_path__ + "static/media/favicon-120.70cf6164.png";